import { useEffect, useState } from "react";
import Modal from "react-responsive-modal";
import metaDataServices from "../MetaDataServices";

export default function Production_listing(param: any) {
    console.log(param)

    const [openFirst, setOpenFirst] = useState(false);
    let [productionlist, Setproductionlist] = useState<any>([]);
    var payLoad = {
        pageNumber: 1,
        pageSize: 10
    }
    useEffect(() => {

        metaDataServices.productionList(payLoad)


    }, [param])

    const returnValue = (e: any) => {
        param.onChange(e)
        setOpenFirst(false)
    }

    const closeProduction_listing = () => {
        param.onChange();
    }

    return (<>
        <Modal open={param.productSelect} onClose={() => returnValue(2)}
            styles={{ modalContainer: { background: 'transparent !important', width: "50% !important" } }}
            center
            classNames={{ overlay: '', modal: 'ws-6 pull-left bgTransparent' }} >
            <div className="box">

                <div className="box-header-main well">
                    <h2>Production</h2>
                </div>

                <div className="ws-12 box pm mtl">

                    <table className="newTable">
                        <thead>
                            <tr>
                                <th >Production Name</th>
                                <th >Production Id</th>
                                <th style={{ width: "15%" }}>Operations</th>
                            </tr>
                        </thead>
                        <tbody>

                            {productionlist.map((row: any) => (
                                <tr>
                                    <td>{row.productionNumber}</td>
                                    <td>{row.productionName}</td>
                                    <td>
                                        <button className="icon-btn edit" title="Edit" type="button" >
                                            <i className="icon-pencil"> </i>
                                        </button>

                                        <button className="icon-btn delete" title="Delete" type="button">
                                            <i className="icon-trash"> </i>
                                        </button>

                                        <button className="icon-btn info" title="Report 801" type="button">
                                            <i className="icon-file"> </i>
                                        </button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>

                    </table>

                </div>

                <div className="ws-12 pm ">
                    <button type="button" className="icon-btn delete pull-right" onClick={() => closeProduction_listing()}>x Close</button>
                </div>

            </div>
        </Modal>

    </>
    )
}